import styled, { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

interface StyledReduceHeaderElementProps {
  $isActive?: boolean;
}

function activeHeaderStyle({ $isActive = false }: StyledReduceHeaderElementProps) {
  if ($isActive) {
    return css`
      background-color: ${Colours.greyLight9};
      border-bottom: 1px solid ${Colours.green};
    `;
  }
}

function activeHeaderNameStyle({ $isActive = false }: StyledReduceHeaderElementProps) {
  if ($isActive) {
    return css`
      color: ${Colours.black};
    `;
  }
}

export default styled.nav`
  box-sizing: border-box;
  margin-top: -1rem;
  margin-right: calc((100% - 100vw) / 2);
  margin-bottom: 4rem;
  margin-left: calc((100% - 100vw) / 2);
  padding-right: calc((100vw - 62.5rem - 2rem) / 2);
  padding-left: calc((100vw - 62.5rem - 2rem) / 2);
  box-shadow: 0 1rem 1rem -0.25rem ${Colours.shadowDark2};
  font-size: 0.75rem;
`;

export const StyledReduceHeaderItems = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledReduceHeaderItem = styled.div``;

export const StyledReduceHeaderElement = styled.div<StyledReduceHeaderElementProps>`
  height: 3.5rem;
  display: flex;
  width: 100%;
  align-items: center;

  &:hover {
    background-color: ${Colours.greyLight9};
  }

  ${activeHeaderStyle}
`;

export const StyledReduceHeaderName = styled.div<StyledReduceHeaderElementProps>`
  padding: 0 1.5rem;
  font-size: 0.933rem;
  font-weight: 400;
  color: ${Colours.slate};
  white-space: nowrap;

  ${activeHeaderNameStyle}
`;

export const StyledReduceHeaderCounterContainer = styled.div`
  height: 1.5rem;
  margin-right: 0.5rem;
  min-width: 1.5rem;
  background-color: ${Colours.blackDark1};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledReduceHeaderCounter = styled.p`
  font-weight: 500;
  color: ${Colours.white};
`;
